import {observer} from 'mobx-react-lite'
import React from 'react'
import {useEffect} from 'react'
import {Hub} from 'yougile-model'
import {StickerStringMultipleMenu} from '@components/multi-actions-with-tasks/actions/sticker-multiple-menu/sticker-string-multiple-menu'
import {useBoolean} from '@containers/hooks'
import {Sticker} from '@extensions/sticker/sticker'
import {useMultiActionsWithTasksStore} from '../multi-actions-with-tasks-store'

export const RenderSticker = observer(
  ({task, cb}: {task: Hub; cb: (close?: boolean) => void}) => {
    const [state, store] = useMultiActionsWithTasksStore()
    if (!state.tag) {
      return null
    }
    const open = useBoolean(true)

    useEffect(() => {
      if (state.applyCustomStickerPopup) {
        store.setTagOpen(false)
        open.turnOff()
      }
    }, [state.applyCustomStickerPopup])

    useEffect(() => {
      !open.value && cb(true)
    }, [open.value])

    useEffect(() => {
      open.turnOn()
    }, [state.tag])

    const type = state.tag && Sticker.getType(state.tag)
    if (type === 'string' || type === 'sprint') {
      return (
        <StickerStringMultipleMenu
          sticker={state.tag}
          stickerType={type}
          task={task}
          tasksFromMultiActions={Array.from(state.tasksIds)}
          cb={open.turnOff}
          onUnpin={() => state.tag && Sticker.unpin(state.tag, task)}
        />
      )
    }

    return <></>
  }
)
